import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

import { getNavigationItems } from '../Navigation/navigation-items';

import { useUserData } from 'context';
import { AnchorElement, VoidFunctionNoArgs } from 'types';
import { Headline4, Menu } from 'views/components';

interface INavigationMenuProps {
  anchorEl: AnchorElement;
  handleClose: VoidFunctionNoArgs;
}

const NavigationMenu: FC<INavigationMenuProps> = props => {
  const { anchorEl, handleClose } = props;
  const { user } = useUserData();
  const items = getNavigationItems(user?.role.name);
  return (
    <Menu anchorEl={anchorEl} onClose={handleClose}>
      {items.map(item => (
        <Menu.Item key={item.path}>
          <NavLink onClick={handleClose} to={item.path}>
            <Headline4>
              <FormattedMessage id={item.titleId} />
            </Headline4>
          </NavLink>
        </Menu.Item>
      ))}
    </Menu>
  );
};
export { NavigationMenu };
